import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      {/* Social Media */}
      <div className="social-section">
        <h3>आम्हाला फॉलो करा</h3>
        <div className="social-icons">
          <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
            <img src="/images/facebook.png" alt="Facebook" className="social-icon" />
          </a>
          <a href="https://x.com" target="_blank" rel="noopener noreferrer">
            <img src="/images/twitter.png" alt="X (Twitter)" className="social-icon" />
          </a>
          <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
            <img src="/images/instagaram.webp" alt="Instagram" className="social-icon" />
          </a>
          <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer">
            <img src="/images/youtube.png" alt="YouTube" className="social-icon" />
          </a>
        </div>
      </div>

      {/* Links */}
      <div className="footer-links">
        <a href="/copyright-policy">Copyright Policy</a>
        <a href="/disclaimer">Disclaimer</a>
        <a href="/privacy-policy">Privacy Policy</a>
        <a href="/contact">Contact Us</a>
      </div>

      {/* Credit */}
      <div className="credit">
        Website Designed, Developed & Maintained by web-solution India Pvt. Ltd. Nagpur<br />
        Content provided by Grampanchayat Office, Government of Maharashtra<br />
        © 2025 web-solution India Pvt. Ltd., Nagpur <br></br>
        Technical issues and updates may require some time for resolution. –<b> <u> 9975797462</u></b>
      </div>

      {/* Government Logos */}
      <div className="gov-logos">
        <a href="https://swachhbharat.mygov.in/" target="_blank" rel="noopener noreferrer">
          <img src="/images/swachh-bharat.png" alt="Swachh Bharat" />
        </a>
        <a href="https://digitalindia.gov.in/" target="_blank" rel="noopener noreferrer">
          <img src="/images/digital-india-logo.png" alt="Digital India" />
        </a>
        <a href="https://data.gov.in/" target="_blank" rel="noopener noreferrer">
          <img src="/images/portal.jpg" alt="Open Government Data Platform" />
        </a>
        <a href="https://www.india.gov.in/" target="_blank" rel="noopener noreferrer">
          <img src="/images/mh_logo.png" alt="National Portal of India" />
        </a>
        <a href="https://www.mygov.in/" target="_blank" rel="noopener noreferrer">
          <img src="/images/mygov.png" alt="MyGov" />
        </a>
        <a href="https://www.meity.gov.in/" target="_blank" rel="noopener noreferrer">
          <img src="/images/Meity_logo.png" alt="Ministry of Electronics and IT" />
        </a>
        <a href="https://www.pmindia.gov.in/" target="_blank" rel="noopener noreferrer">
          <img src="/images/pm-india-logo.jpg" alt="PM India" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;